import React from 'react';

import { Button, Flex, FlexProps, Text, Title } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import { FullScreenAlert } from 'components/FullScreenAlert';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AuthService } from 'services/auth-service';
import { ROUTE_LINKS } from 'shared/constants/route-links';

type DataNotFoundAlertProps = FlexProps;

export function DataNotFoundAlert({ ...flexProps }: DataNotFoundAlertProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <FullScreenAlert
      showLanguageChange={false}
      body={
        <Flex align="center" justify="space-between" direction="column">
          <Title fz={70} mt="md">
            {t('APP.NOT_FOUND.CODE')}
          </Title>

          <Text maw={350} align="center">
            {t('APP.NOT_FOUND.TITLE')}
          </Text>

          <Button
            mt="md"
            variant="default"
            rightIcon={<IconArrowRight />}
            onClick={() =>
              AuthService.isAuthenticated() ? navigate(ROUTE_LINKS.smartAssistants) : navigate(ROUTE_LINKS.login)
            }>
            {t('APP.NOT_FOUND.BACK_HOME')}
          </Button>
        </Flex>
      }
      pb={0}
      {...flexProps}
    />
  );
}
